import React, { useState, useEffect } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import classnames from "classnames";
import Slides from "./slides";
import Pdf from "./pdf";
import * as loaderAction from "../../redux/loader/action";
import Socket from "../../socket/socket";
import aberlourImg from "../../assets/images/slide-kick/aberlour.png";

const Tabs = (props) => {
  const roomData = _.get(props, "gameReducer.roomObj");
  const joining_data = _.get(props, "paramsReducer.gameObj.joining");
  const slides_tab = _.get(joining_data, "slides_tab", "Slides");
  const pdf_tab = _.get(joining_data, "pdf_tab", "PDF");
  const back_button = _.get(joining_data, "back_button", "BACK");
  const open_room_button = _.get(joining_data, "open_room_button", "Open Room");

  const [activeTab, setActiveTab] = useState("1");
  const [openRoomDisabled, setopenRoomDisabled] = useState(true);

  const [slides_hero_link, set_slides_hero_link] = useState("");
  const [slides_slidekick_link, set_slides_slidekick_link] = useState("");
  const [slides_slidekick_only, set_slides_slidekick_only] = useState(false);
  const [show_slides_status, set_show_slides_status] = useState(false);

  const [pdf_hero_link, set_pdf_hero_link] = useState("");
  const [pdf_slidekick_link, set_pdf_slidekick_link] = useState("");
  const [pdf_slidekick_only, set_pdf_slidekick_only] = useState(false);
  const [show_pdf_status, set_show_pdf_status] = useState(false);

  useEffect(() => {
    return Socket.addListener("submit-slides", (res) => {
      console.log(res, "rerererer");
      console.log(res, "slidekick log");
      props.setIsLoading(false);
      if (res.slideType === "pdf") {
        set_show_pdf_status(true);
      } else if (res.slideType === "google_slides") {
        set_show_slides_status(true);
      }
    });
  }, []);

  const handle_hero_link = (value, type) => {
    if (type === "pdf") {
      set_pdf_hero_link(value);
    } else if (type === "slides") {
      set_slides_hero_link(value);
    }
  };

  const handle_slidekick_link = (value, type) => {
    if (type === "pdf") {
      set_pdf_slidekick_link(value);
    } else if (type === "slides") {
      set_slides_slidekick_link(value);
    }
  };

  const handle_slidekick_only = (type) => {
    if (type === "pdf") {
      set_pdf_slidekick_only((prev_val) => !prev_val);
    } else if (type === "slides") {
      set_slides_slidekick_only((prev_val) => !prev_val);
    }
  };

  const handle_submit = (url, heroSlidekick, slidekickOnly, slideType) => {
    props.setIsLoading(true);
    let data = {
      action: "submit-slides",
      roomId: roomData.id,
      url,
      slideType,
      heroSlidekick,
      slidekickOnly,
    };
    Socket.sendMessage(data);
  };

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div className="tabs-wrapper">
      <div className="navigation-tabs d-flex">
        <div className="nav-tabs-wrapper">
          <div className="navigation-item">
            <div
              className={classnames("navigation-link", {
                active: activeTab === "1",
              })}
              onClick={() => {
                toggle("1");
              }}
            >
              {slides_tab}
            </div>
          </div>
          <div className="navigation-item">
            <div
              className={classnames("navigation-link", {
                active: activeTab === "2",
              })}
              onClick={() => {
                toggle("2");
              }}
            >
              {pdf_tab}
            </div>
          </div>
        </div>
        {/* <div>
          <img src={aberlourImg} className="aberlour-img" alt="aberlourImg" />
        </div> */}
      </div>
      {activeTab == "1" && (
        <div className="tab-content">
          <Slides
            handle_submit={handle_submit}
            setopenRoomDisabled={setopenRoomDisabled}
            slides_hero_link={slides_hero_link}
            slides_slidekick_link={slides_slidekick_link}
            slides_slidekick_only={slides_slidekick_only}
            handle_hero_link={handle_hero_link}
            handle_slidekick_link={handle_slidekick_link}
            handle_slidekick_only={handle_slidekick_only}
            show_slides_status={show_slides_status}
          />
        </div>
      )}
      {activeTab === "2" && (
        <div className="tab-content">
          <Pdf
            handle_submit={handle_submit}
            setopenRoomDisabled={setopenRoomDisabled}
            pdf_hero_link={pdf_hero_link}
            pdf_slidekick_link={pdf_slidekick_link}
            pdf_slidekick_only={pdf_slidekick_only}
            handle_hero_link={handle_hero_link}
            handle_slidekick_link={handle_slidekick_link}
            handle_slidekick_only={handle_slidekick_only}
            show_pdf_status={show_pdf_status}
          />
        </div>
      )}
      <div className="lobby-footer">
        <button type="button" className="btn" onClick={() => props.onBack()}>
          {back_button}
        </button>
        <button
          type="button"
          onClick={() => props.set_show_slidekick_players(true)}
          disabled={openRoomDisabled}
          className={openRoomDisabled ? "disabled" : "btn btn-success"}
        >
          {open_room_button}
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Tabs);
